import { account, auth } from './account'
import { audio } from './audio'
import { affilate } from './team'

export const api = {
  auth,
  account,
  audio,
  affilate
}

export * from './account/models'

// Models
export * from './audio/models'
export * from './audio/utils'

export type * from './types'
